import { render, staticRenderFns } from "./mdTopicltems.vue?vue&type=template&id=48982d68&scoped=true&"
import script from "./mdTopicltems.vue?vue&type=script&lang=js&"
export * from "./mdTopicltems.vue?vue&type=script&lang=js&"
import style0 from "./mdTopicltems.vue?vue&type=style&index=0&id=48982d68&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48982d68",
  null
  
)

export default component.exports